import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { services } from '../data/services';
export function Services() {
  const [activeId, setActiveId] = useState(services[0].id);
  const active = services.find(s => s.id === activeId) ?? services[0];
  return <section id="services" className="bg-parchment py-24" data-id="element-242" data-mp="18ufxxzd4vnv3">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-243" data-mp="13wehlm73e2nb">
        <p className="eyebrow text-green-dark" data-id="element-244" data-mp="13x63g5aw0m0e">What We Do</p>
        <h2 className="mt-5 max-w-2xl font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-245" data-mp="z43gig0m8at6">
          Six disciplines, one advisory relationship.
        </h2>
        <div className="double-rule mt-7 w-24 text-ink" aria-hidden="true" data-id="element-246" data-mp="q5hqjzstdtid" />

        <div className="mt-12 grid border border-line bg-paper lg:grid-cols-[0.85fr_1.15fr]" data-id="element-247" data-mp="l5wqtn5tlh4l">
          <ul className="border-b border-line lg:border-b-0 lg:border-r" role="tablist" aria-label="Service disciplines" data-id="element-248" data-mp="g6k18unkdvyb">
            {services.map(service => {
            const isActive = service.id === activeId;
            return <li key={service.id} className="border-b border-line/70 last:border-b-0" data-id="element-249" data-mp="2xc1hj1bhegvv">
                  <button type="button" role="tab" id={`tab-${service.id}`} aria-selected={isActive} aria-controls={`panel-${service.id}`} onClick={() => setActiveId(service.id)} className={`group flex w-full items-center gap-4 border-l-2 px-6 py-5 text-left transition-colors ${isActive ? 'border-green bg-white' : 'border-transparent hover:bg-white/60'}`} data-id="element-250" data-mp="32aw0c39g85fz">
                    <span className={`font-mono text-[11px] ${isActive ? 'text-green-dark' : 'text-ink-50'}`} data-id="element-251" data-mp="29lxhf3xi4z9m">
                      {service.index}
                    </span>
                    <span className={`flex-1 font-display text-[18px] ${isActive ? 'text-ink' : 'text-ink-70'}`} data-id="element-252" data-mp="1lklo85wqn4jy">
                      {service.name}
                    </span>
                    <ArrowRightIcon className={`h-4 w-4 transition-transform ${isActive ? 'text-green-dark' : 'text-ink-50/60 group-hover:translate-x-0.5'}`} aria-hidden="true" data-id="element-253" data-mp="16ue31ifcj7fk" />
                  </button>
                </li>;
          })}
          </ul>

          <div className="bg-white p-8 sm:p-10" data-id="element-254" data-mp="2s4uyw9rmufqg">
            <AnimatePresence mode="wait" data-id="element-255" data-mp="2n7l0i4m9mtqh">
              <motion.div key={active.id} id={`panel-${active.id}`} role="tabpanel" aria-labelledby={`tab-${active.id}`} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.25,
              ease: [0.22, 1, 0.36, 1]
            }} data-id="element-256" data-mp="2n5ru8qfkebj0">
                <h3 className="font-display text-[28px] font-medium text-ink" data-id="element-257" data-mp="39i31gci8invb">
                  {active.name}
                </h3>
                <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-ink-70" data-id="element-258" data-mp="2gqt17w89mgpi">
                  {active.description}
                </p>

                <ul className="mt-8 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-259" data-mp="2lpe4k4itdgi6">
                  {active.items.map(item => <li key={item} className="flex items-start gap-3 border-b border-line/70 pb-3 text-[14px] text-ink" data-id="element-260" data-mp="10gjqxw27kdn">
                      <span className="mt-0.5 font-mono text-[12px] text-green-dark" aria-hidden="true" data-id="element-261" data-mp="53wf7qwe7eor">
                        ✓
                      </span>
                      {item}
                    </li>)}
                </ul>

                <a href="#contact" className="mt-9 inline-flex items-center gap-2 border border-ink/30 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-262" data-mp="8k941nvst778">
                  Discuss This Service
                  <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-263" data-mp="w9tn06ryc4gi" />
                </a>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}